import { constantDarkValues, constantLightValues } from '../share/constants';
export const defaultLinkTextTheme = {
  LinkText: {
    dark: constantDarkValues,
    light: constantLightValues
  }
};